import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import UserAvatar from './UserAvatar';

import ActionLink from '../builder/ActionLink';

const MyParticipationMenuHeader = (props) => {
	useCSS('comp/my_participation.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const in_sidebar = props?.in_sidebar ?? false;
	const promotion_id = props?.promotion_id ?? false;

	const login_id = props?.login_id ?? false;
	const login_data = props?.login_data ?? false;
	const net_type = login_data?.net_type ?? false;
	const hide_won_prizes_in_header = props?.hide_won_prizes_in_header ?? true;

	const [ display_menu, setDisplayMenu ] = useState((!in_sidebar) ? false : true);

	const toggleMenu = () => {
		if(in_sidebar) return true;
		setDisplayMenu(!display_menu);
	};

	if(!promotion_id) return null;
	if(!in_sidebar && (login_id === false || login_data === false)) return null;

	// if user is a guest, don't display the log information
	if(net_type === false || parseInt(net_type) == 7) return null;
	
	if(in_sidebar && (!login_id || !login_data)) {
		return (
			<div class="header_my_participation in_sidebar not_logged_in">
				<div class="user_main_info knk-annonymous-users">
					<p>{i18n("Already a participant?")}</p>

					<ActionLink _href={`/login/${promotion_id}`} _target="_top">Sign in</ActionLink>
				</div>
			</div>
		)
	}

	let display_name = login_data.first_name;
	if(isNotEmpty(login_data, 'option')) display_name = login_data.name; 

	const cards = login_data?.loyalty?.cards ?? [];
	const is_multicard = (cards.length > 1) ? true : false;
	
	const display_prize_shop = props?.display_prize_shop ?? false;
	const loyalty_shop_url = `/loyalty/prize_gallery/${promotion_id}`;

	return (
		<div class={'header_my_participation' + ((in_sidebar) ? ' in_sidebar' : '')}>
			{(display_menu && !in_sidebar) && (
				<div class="is_fullscreen" onClick={() => toggleMenu()} />
			)}

			<div class={'user_main_info' + ((!in_sidebar) ? ' knk-arrow-b-big' : '')} onClick={() => toggleMenu()}>
				<span class="logged_name hb_secondaryFont not_uppercase">{display_name}</span>

				<UserAvatar
					user={login_data}
					width={2.25}
					height={2.25}
				/>
			</div>

			{(display_menu || in_sidebar) && (
				<ul class="gui_dropper_menu">
					<li class="my_participation_btn">
						<ActionLink
							icon='knk-me'
							_href={`/users/my_participation/${promotion_id}`}
							_class={{ other:((in_sidebar) ? 'gui_small_icon' : null) }}
						>My participation</ActionLink>
					</li>

					{cards.map((card) => {
						let label = i18n("My card");
						if(is_multicard) label += `: ${card.title}`;

						return (
							<li key={`card_${card.id}`} class="card_btn">
								<ActionLink
									icon='knk-punch-card'
									_href={`/loyalty/cards/${promotion_id}/${card.id}`}
									_class={{ other:((in_sidebar) ? 'gui_small_icon' : null) }}
								>{label}</ActionLink>
							</li>
						)
					})}

					{(display_prize_shop) && (
						<li class="prize_gallery_btn">
							<ActionLink
								icon='knk-money'
								_href={loyalty_shop_url}
								_class={{ other:((in_sidebar) ? 'gui_small_icon' : null) }}
							>Redeem your coins</ActionLink>
						</li>
					)}
						
					{(!hide_won_prizes_in_header) && (
						<li class="won_prizes_btn">
							<ActionLink
								icon='knk-winners'
								_href={`/my_prizes/${promotion_id}/`}
								_class={{ other:((in_sidebar) ? 'gui_small_icon' : null) }}
							>My prizes</ActionLink>
						</li>
					)}

					<li class="logout_btn">
						<ActionLink
							icon='knk-logout'
							_href={`/promotions/logout/${promotion_id}`}
							_class={{ other:((in_sidebar) ? 'gui_small_icon' : null) }}
						>Logout</ActionLink>
					</li>
				</ul>
			)}
		</div>
	);
}

export default injectIntl(MyParticipationMenuHeader);